let loginAllowed = true;

export function preventDeviceLogin() {
    loginAllowed = false;
}

export function isDeviceLoginAllowed() {
    let result = loginAllowed;
    loginAllowed = true;
    return result;
}